<template>
	<div>
		<!-- 顶部显示的页面 -->
		<el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom:10px">
			<el-breadcrumb-item :to="{ path: '/couponPackage' }">券包管理</el-breadcrumb-item>
			<el-breadcrumb-item>优惠券列表</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 新增套餐的按钮 -->
		<div>
			<el-button v-if="dataList.length<6" type="primary" @click="NewlyAdded">新增</el-button>
		</div>
		<div style="margin-top:20px">
			<el-table :data="dataList">
				<el-table-column label="批次券名称" width="200" prop="stock_name"/>
				<el-table-column label="适用商品范围" width="150" prop="goods_name"/>
				<el-table-column label="批次号" width="150" prop="stock_id"/>
				<el-table-column label="背景颜色" width="80" prop="background_color">
					<template slot-scope="scope">
						<div :style="'width: 30px;height: 20px;display:inline-block;background-color:'+wxtoColor(scope.row.background_color)"></div>
					</template>
				</el-table-column>
				<el-table-column label="优惠券图片" width="90">
					<template slot-scope="scope">
						<img :src="scope.row.coupon_image_url" width="40" alt="">
					</template>
				</el-table-column>
				<el-table-column label="使用须知 " prop="description"/>
				<el-table-column label="批次备注" prop="comment"/>
				<el-table-column label="创建日期" width="160" prop="create_date"/>
				<el-table-column label="操作" width="160" v-if="needCode">
					<template slot-scope="scope">
						<!--						<el-button size="mini" @click="edit(scope.row)">编辑</el-button>-->
						<!--						<el-button size="mini" type="danger" @click="del(scope.row)">删除</el-button>-->
						<el-button size="mini" @click="codeAdd(scope.row)">添加code</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- 分页 -->
		<!--		<div>-->
		<!--			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"-->
		<!--						   :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"-->
		<!--						   layout="total,  prev, pager, next, jumper"-->
		<!--						   :total="total"-->
		<!--						   style="text-align:right;margin:0 16px 10px 0;border-radius:20px"></el-pagination>-->
		<!--		</div>-->
	</div>
</template>

<script>
import qs from "qs";
import coupon from "../api/coupons";
import {request} from "../axios/index";

export default {
	props: {
		pageSize: {
			type: Number,
			default: 10
		}
	},
	data() {
		return {
			tableData: [],
			scenicAll: [],
			input: '',
			currentPage: 1,   //分页
			total: 0,        //分页
			dataList: [],
			editDialogVisible: false,   //商品编辑的弹框
			editInfo: [],               //商品编辑的数据集合
			wxColors: [{value: 'Color010', color: '#63B359'},
				{value: 'Color020', color: '#2C9F67'},
				{value: 'Color030', color: '#509FC9'},
				{value: 'Color040', color: '#5885CF'},
				{value: 'Color050', color: '#9062C0'},
				{value: 'Color060', color: '#D09A45'},
				{value: 'Color070', color: '#E48138'},
				{value: 'Color080', color: '#EE903C'},
				{value: 'Color090', color: '#DD6549'},
				{value: 'Color100', color: '#CC463D'}],
			quaryList: {
				coupon_package_id: undefined
			},
			needCode: false
		}
	},
	mounted() {
		if (this.$datas.couponPackage.couponsRule.coupon_code_mode !== 'WECHATPAY_MODE') {
			this.needCode = true;
		}
		if (this.$datas.couponPackage.id) {
			this.quaryList.coupon_package_id = this.$datas.couponPackage.id;
			this.getCouponList();
		} else {
			this.$router.push({
				path: "/couponPackage"
			});
		}
	},
	methods: {
		// 新增按钮的方法
		NewlyAdded() {
			this.$router.push({
				path: "/coupon",
				query: {type: 0}
			});
		},
		getCouponList() {
			coupon.getCouponList(this.quaryList).then(res => {
				this.dataList = res.list;
			})
		},
		wxtoColor(val) {
			for (let i = 0; i < this.wxColors.length; i++) {
				if (this.wxColors[i].value === val) {
					return this.wxColors[i].color;
				}
			}
		},
		codeAdd(row) {
			console.log(row.stock_id);
			let timestamp = new Date().getTime();
			let stock_id = row.stock_id;
			request({
				url: `http://m5u9rw.natappfree.cc/wx/serviceProvider/couponcodes`, data: {
					stock_id,
					coupon_code_list: ['272738318', '388925951', '827475911', '732276930', '827475911','272738319', '388925952', '827475913', '732276935', '827475917'].join(),
					upload_request_no: timestamp + '223698'
				}, method: 'post'
			}).then(res => {
				console.log(res)
			})
		},
		// 用户编辑
		edit(row) {
			this.$router.push({
				path: "/coupon",
				query: {type: 1}
			});
		},
		Preservation() {
			this.editDialogVisible = false
			var userData = qs.parse(sessionStorage.getItem("userData"));
			var that = this;
			var area_ids = []
			var prices = []
			this.bulletList.forEach(item => {
				area_ids.push(item.area_id)
			});
			var areaID = area_ids.join(",")
			var originaiPrices = this.packagePriceNumber.join(",")
			var salesInfoData = {
				do_lx: 2,
				package_id: this.packageId,
				area_id: areaID,
				area_price: originaiPrices,
				package_name: this.packageName
			};
			var salesInfoParams = {
				methodUrl: "/admin/addPackageInfo",
				jsonParam: qs.stringify(salesInfoData)
			};
			this.$axios.postRequest(salesInfoParams).then(
					function (res) {

						if (res.code == 0) {
							that.findScenicSpot()
							that.dialogVisible = false
						} else {
							that.$message.error(res.msg);
						}
					},
					function (res) {
						//失败之后处理逻辑
						console.log(res);
						that.$message.error('网络错误')
					}
			);
		},
		del(row) {//删除
			console.log(row)
			let id = row.id;
			this.$confirm('确认删除?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				coupon.deleteCoupon({id}).then(res => {
					this.$message({
						type: 'success',
						showClose: true,
						message: '删除成功!'
					});
				})
			})
		},
		// 分页
		handleSizeChange(val) {
			this.pageSize = val;
			this.findScenicSpot();
		},
		handleCurrentChange(val) {
			this.currentPage = val;
			this.findScenicSpot();
		},

		// 表格
		// handleEdit (index, row) {
		//   console.log(index, row);
		// },
		// handleDelete (index, row) {
		//   console.log(index, row);
		// }
		ViewDetails(index, row) {
		}
	},
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/couponList.vue